import {Kind} from 'graphql';

import type {
  DocumentNode,
  OperationDefinitionNode,
  OperationTypeNode,
} from 'graphql';

function findOperationDefinition(
  doc: DocumentNode,
): OperationDefinitionNode | undefined {
  return doc.definitions.find((def) => def.kind === Kind.OPERATION_DEFINITION);
}

export function getOperationName(doc: DocumentNode): string | null {
  return findOperationDefinition(doc)?.name?.value ?? null;
}

export function getOperationType(doc: DocumentNode): OperationTypeNode | null {
  return findOperationDefinition(doc)?.operation ?? null;
}
